import styled from 'styled-components'
import { useRouter } from 'next/router'
import { TransparentButton } from 'common/button'
import { MdClose } from 'react-icons/md'

const FilterTagsStyled = styled.ul`
  margin-block-start: 16px;
  display: flex;
  gap: 8px;
  font: var(--p2Regular);
  .tag {
    background: var(--neutral100);
    color: var(--white);
    padding: 4px 8px;
    border-radius: 4px;
    gap: 4px;
  }
  .remove-all {
    text-decoration: underline;
    font: var(--p2Bold);
    font-weight: 600;
  }
`

function FilterTags({ filters }) {
  const router = useRouter()
  const { query } = router
  const tags = filters.map((arr) => arr.options).flat()
  const queryTags = { ...query }
  delete queryTags.search
  const filterValues = Object.values(queryTags)
  const filterKeys = Object.keys(queryTags)

  const removeAll = () => {
    const url = window.location.pathname
    router.replace(url, '', {
      shallow: true,
      scroll: false,
    })
  }

  const removeParam = (tag) => {
    const url = window.location.pathname
    const newQuery = { ...query }
    const deletedKey = filterKeys.find((key) => query[key] === tag)
    delete newQuery[deletedKey]
    router.replace({
      pathname: url,
      query: newQuery,
    }, '', {
      shallow: true,
      scroll: false,
    })
  }

  if (filterValues.length > 0) {
    return (
      <FilterTagsStyled>
        {filterValues.map((tag) => (
          <li>
            <TransparentButton className="tag" onClick={() => removeParam(tag)}>
              {tags.find((item) => item.param === tag)?.option}
              <MdClose size={22} />
            </TransparentButton>
          </li>
        ))}
        <TransparentButton className="remove-all" onClick={() => removeAll()}>
          Borrar todos
        </TransparentButton>
      </FilterTagsStyled>
    )
  }

  return null
}

export default FilterTags
